<template>
  <div class="row">
    <div class="col-sm-12">
      <div v-html="blockData.text"></div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  blockData: Object

})
</script>
